import React from 'react';
import './driverTraining.css';
import Template01 from './templates/template01.js';
import { BrowserRouter as Router, Route, Routes, useRoutes } from 'react-router-dom';

export const DriverTraining = () => {
  const element = <Template01 />;

  const trainingVersions =
    [
      '/training/01/nyc','/training/01/nyc/english','/training/01/nyc/bengali','/training/01/nyc/spanish',
      '/training/01/nyc/01','/training/01/nyc/01/english','/training/01/nyc/01/bengali','/training/01/nyc/01/spanish',
      '/training/01/chi','/training/01/chi/english','/training/01/chi/spanish','/training/01/chi/bengali',
      '/training/01/phl','/training/01/phl/english','/training/01/phl/spanish','/training/01/phl/bengali',
      '/training/01/dc', '/training/01/dc/english','/training/01/dc/bengali','/training/01/dc/spanish',
      '/training/01/la','/training/01/la/english','/training/01/la/spanish','/training/01/la/bengali',
      '/training/01/bos','/training/01/bos/english','/training/01/bos/spanish','/training/01/bos/bengali',
      '/training/01/miami','/training/01/miami/english','/training/01/miami/spanish','/training/01/miami/bengali',
      '/training/01/fort_lau','/training/01/fort_lau/english','/training/01/fort_lau/spanish','/training/01/fort_lau/bengali',
      '/training/01/nola','/training/01/nola/english','/training/01/nola/spanish','/training/01/nola/bengali',
      '/training/01/sanfran','/training/01/sanfran/english','/training/01/sanfran/spanish','/training/01/sanfran/bengali',
      '/training/01/wpb','/training/01/wpb/english','/training/01/wpb/spanish','/training/01/wpb/bengali',
      '/training/01/sandi','/training/01/sandi/english','/training/01/sandi/spanish','/training/01/sandi/bengali',
      '/training/01/las','/training/01/las/english','/training/01/las/spanish','/training/01/las/bengali',
      '/training/01/nyc/02','/training/01/nyc/02/english',
      '/training/01/chi/02','/training/01/chi/02/english',
      '/training/01/phl/02','/training/01/phl/02/english',
      '/training/01/dc/02', '/training/01/dc/02/english',
      '/training/01/la/02','/training/01/la/02/english',
      '/training/01/bos/02','/training/01/bos/02/english',
      '/training/01/miami/02','/training/01/miami/02/english',
      '/training/01/fort_lau/02','/training/01/fort_lau/02/english',
      '/training/01/nola/02','/training/01/nola/02/english',
      '/training/01/sanfran/02','/training/01/sanfran/02/english',
      '/training/01/wpb/02','/training/01/wpb/02/english',
      '/training/01/buff/02','/training/01/buff/02/english',
      '/training/02/nyc','/training/02/nyc/english','/training/02/nyc/bengali','/training/02/nyc/spanish',
      '/training/02/nyc/01','/training/02/nyc/01/english',
      '/training/02/chi','/training/02/chi/english','/training/02/chi/bengali','/training/02/chi/spanish',
      '/training/02/phl','/training/02/phl/english','/training/02/phl/spanish','/training/02/phl/bengali',
      '/training/02/dc', '/training/02/dc/english','/training/02/dc/bengali','/training/02/dc/spanish',
      '/training/02/la','/training/02/la/english','/training/02/la/spanish','/training/02/la/bengali',
      '/training/02/bos','/training/02/bos/english','/training/02/bos/spanish','/training/02/bos/bengali',
      '/training/02/miami','/training/02/miami/english','/training/02/miami/spanish','/training/02/miami/bengali',
      '/training/02/fort_lau','/training/02/fort_lau/english','/training/02/fort_lau/spanish','/training/02/fort_lau/bengali',
      '/training/02/nola','/training/02/nola/english','/training/02/nola/spanish','/training/02/nola/bengali',
      '/training/02/sanfran','/training/02/sanfran/english','/training/02/sanfran/spanish','/training/02/sanfran/bengali',
      '/training/02/wpb','/training/02/wpb/english','/training/02/wpb/spanish','/training/02/wpb/bengali',
      '/training/02/sandi','/training/02/sandi/english','/training/02/sandi/spanish','/training/02/sandi/bengali',
      '/training/02/las','/training/02/las/english','/training/02/las/spanish','/training/02/las/bengali',
      '/training/02/nyc/01','/training/02/nyc/01/english',
      '/training/02/chi/01','/training/02/chi/01/english',
      '/training/02/phl/01','/training/02/phl/01/english',
      '/training/02/dc/01', '/training/02/dc/01/english',
      '/training/02/la/01','/training/02/la/01/english',
      '/training/02/bos/01','/training/02/bos/01/english',
      '/training/02/miami/01','/training/02/miami/01/english',
      '/training/02/fort_lau/01','/training/02/fort_lau/01/english',
      '/training/02/nola/01','/training/02/nola/01/english',
      '/training/02/sanfran/01','/training/02/sanfran/01/english',
      '/training/02/wpb/01','/training/02/wpb/01/english',
      '/training/02/sandi/01','/training/02/sandi/01/english',
      '/training/02/las/01','/training/02/las/01/english',
      '/training/02/buff/01','/training/02/buff/01/english',
      '/training/03/nyc','/training/03/nyc/english',
      '/training/03/chi','/training/03/chi/english',
      '/training/03/phl','/training/03/phl/english',
      '/training/03/dc', '/training/03/dc/english',
      '/training/03/la','/training/03/la/english',
      '/training/03/bos','/training/03/bos/english',
      '/training/03/miami','/training/03/miami/english',
      '/training/03/fort_lau','/training/03/fort_lau/english',
      '/training/03/nola','/training/03/nola/english',
      '/training/03/reno','/training/03/reno/english',
      '/training/03/sanfran','/training/03/sanfran/english',
      '/training/03/wpb','/training/03/wpb/english',
      '/training/03/ral','/training/03/ral/english',
      '/training/03/char','/training/03/char/english',
      '/training/03/sandi','/training/03/sandi/english',
      '/training/03/las','/training/03/las/english',
      '/training/03/buff','/training/03/buff/english',
      '/training/03/sea','/training/03/sea/english',
      '/training/03/new','/training/03/new/english',
      '/training/04/nyc','/training/04/nyc/english',
      '/training/04/chi','/training/04/chi/english',
      '/training/04/phl','/training/04/phl/english',
      '/training/04/dc', '/training/04/dc/english',
      '/training/04/la','/training/04/la/english',
      '/training/04/bos','/training/04/bos/english',
      '/training/04/miami','/training/04/miami/english',
      '/training/04/fort_lau','/training/04/fort_lau/english',
      '/training/04/nola','/training/04/nola/english',
      '/training/04/reno','/training/04/reno/english',
      '/training/04/sanfran','/training/04/sanfran/english',
      '/training/04/wpb','/training/04/wpb/english',
      '/training/04/ral','/training/04/ral/english',
      '/training/04/char','/training/04/char/english',
      '/training/04/sandi','/training/04/sandi/english',
      '/training/04/las','/training/04/las/english',
      '/training/04/sea','/training/04/sea/english',
      '/training/04/new','/training/04/new/english',
      '/training/04/nyc/01','/training/04/nyc/01/english',
      '/training/04/chi/01','/training/04/chi/01/english',
      '/training/04/phl/01','/training/04/phl/01/english',
      '/training/04/dc/01', '/training/04/dc/01/english',
      '/training/04/la/01','/training/04/la/01/english',
      '/training/04/bos/01','/training/04/bos/01/english',
      '/training/04/miami/01','/training/04/miami/01/english',
      '/training/04/fort_lau/01','/training/04/fort_lau/01/english',
      '/training/04/nola/01','/training/04/nola/01/english',
      '/training/04/reno/01','/training/04/reno/01/english',
      '/training/04/sanfran/01','/training/04/sanfran/01/english',
      '/training/04/wpb/01','/training/04/wpb/01/english',
      '/training/04/ral/01','/training/04/ral/01/english',
      '/training/04/char/01','/training/04/char/01/english',
      '/training/04/sandi/01','/training/04/sandi/01/english',
      '/training/04/las/01','/training/04/las/01/english',
      '/training/04/buff/01','/training/04/buff/01/english',
      '/training/05/nyc','/training/05/nyc/english',
      '/training/05/chi','/training/05/chi/english',
      '/training/05/phl','/training/05/phl/english',
      '/training/05/dc', '/training/05/dc/english',
      '/training/05/la','/training/05/la/english',
      '/training/05/bos','/training/05/bos/english',
      '/training/05/miami','/training/05/miami/english',
      '/training/05/fort_lau','/training/05/fort_lau/english',
      '/training/05/nola','/training/05/nola/english',
      '/training/05/reno','/training/05/reno/english',
      '/training/05/sanfran','/training/05/sanfran/english',
      '/training/05/wpb','/training/05/wpb/english',
      '/training/06/nyc','/training/06/nyc/english',
      '/training/06/chi','/training/06/chi/english',
      '/training/06/phl','/training/06/phl/english',
      '/training/06/dc', '/training/06/dc/english',
      '/training/06/la','/training/06/la/english',
      '/training/06/bos','/training/06/bos/english',
      '/training/06/miami','/training/06/miami/english',
      '/training/06/fort_lau','/training/06/fort_lau/english',
      '/training/06/nola','/training/06/nola/english',
      '/training/06/sanfran','/training/06/sanfran/english',
      '/training/06/wpb','/training/06/wpb/english',
      '/training/06/sandi','/training/06/sandi/english',
      '/training/06/las','/training/06/las/english',
      '/training/06/nyc/01','/training/06/nyc/01/english',
      '/training/06/chi/01','/training/06/chi/01/english',
      '/training/06/phl/01','/training/06/phl/01/english',
      '/training/06/dc/01', '/training/06/dc/01/english',
      '/training/06/la/01','/training/06/la/01/english',
      '/training/06/bos/01','/training/06/bos/01/english',
      '/training/06/miami/01','/training/06/miami/01/english',
      '/training/06/fort_lau/01','/training/06/fort_lau/01/english',
      '/training/06/nola/01','/training/06/nola/01/english',
      '/training/06/sanfran/01','/training/06/sanfran/01/english',
      '/training/06/wpb/01','/training/06/wpb/01/english',
      '/training/06/sandi/01','/training/06/sandi/01/english',
      '/training/06/las/01','/training/06/las/01/english',
      '/training/06/buff/01','/training/06/buff/01/english',
      '/training/07/nyc','/training/07/nyc/english',
      '/training/07/chi','/training/07/chi/english',
      '/training/08/nyc','/training/08/nyc/english','/training/08/nyc/bengali','/training/08/nyc/spanish',
      '/training/08/chi','/training/08/chi/english','/training/08/chi/spanish','/training/08/chi/bengali',
      '/training/08/phl','/training/08/phl/english','/training/08/phl/spanish','/training/08/phl/bengali',
      '/training/08/dc', '/training/08/dc/english','/training/08/dc/bengali','/training/08/dc/spanish',
      '/training/08/la','/training/08/la/english','/training/08/la/spanish','/training/08/la/bengali',
      '/training/08/bos','/training/08/bos/english','/training/08/bos/spanish','/training/08/bos/bengali',
      '/training/08/miami','/training/08/miami/english','/training/08/miami/spanish','/training/08/miami/bengali',
      '/training/08/fort_lau','/training/08/fort_lau/english','/training/08/fort_lau/spanish','/training/08/fort_lau/bengali',
      '/training/08/nola','/training/08/nola/english','/training/08/nola/spanish','/training/08/nola/bengali',
      '/training/08/reno','/training/08/reno/english','/training/08/reno/spanish','/training/08/reno/bengali',
      '/training/08/sanfran','/training/08/sanfran/english','/training/08/sanfran/spanish','/training/08/sanfran/bengali',
      '/training/08/wpb','/training/08/wpb/english','/training/08/wpb/spanish','/training/08/wpb/bengali',
      '/training/09/nyc','/training/09/nyc/english',
      '/training/09/chi','/training/09/chi/english',
      '/training/09/phl','/training/09/phl/english',
      '/training/09/dc', '/training/09/dc/english',
      '/training/09/la','/training/09/la/english',
      '/training/09/bos','/training/09/bos/english',
      '/training/09/miami','/training/09/miami/english',
      '/training/09/fort_lau','/training/09/fort_lau/english',
      '/training/09/nola','/training/09/nola/english',
      '/training/09/reno','/training/09/reno/english',
      '/training/09/sanfran','/training/09/sanfran/english',
      '/training/09/wpb','/training/09/wpb/english',
      '/training/09/ral','/training/09/ral/english',
      '/training/09/char','/training/09/char/english',
      '/training/09/sandi','/training/09/sandi/english',
      '/training/09/las','/training/09/las/english',
      '/training/09/sea','/training/09/sea/english',
      '/training/09/new','/training/09/new/english',
      '/training/10/nyc','/training/10/nyc/english',
      '/training/10/chi','/training/10/chi/english',
      '/training/10/phl','/training/10/phl/english',
      '/training/10/dc', '/training/10/dc/english',
      '/training/10/la','/training/10/la/english',
      '/training/10/bos','/training/10/bos/english',
      '/training/10/miami','/training/10/miami/english',
      '/training/10/fort_lau','/training/10/fort_lau/english',
      '/training/10/nola','/training/10/nola/english',
      '/training/10/reno','/training/10/reno/english',
      '/training/10/sanfran','/training/10/sanfran/english',
      '/training/10/wpb','/training/10/wpb/english',
      '/training/10/ral','/training/10/ral/english',
      '/training/10/char','/training/10/char/english',
      '/training/10/sandi','/training/10/sandi/english',
      '/training/10/las','/training/10/las/english',
      '/training/10/sea','/training/10/sea/english',
      '/training/11/la','/training/11/la/english',
      '/training/12/nyc','/training/12/nyc/english',
      '/training/12/chi','/training/12/chi/english',
      '/training/12/phl','/training/12/phl/english',
      '/training/12/dc', '/training/12/dc/english',
      '/training/12/la','/training/12/la/english',
      '/training/12/bos','/training/12/bos/english',
      '/training/12/miami','/training/12/miami/english',
      '/training/12/fort_lau','/training/12/fort_lau/english',
      '/training/12/nola','/training/12/nola/english',
      '/training/12/reno','/training/12/reno/english',
      '/training/12/sanfran','/training/12/sanfran/english',
      '/training/12/wpb','/training/12/wpb/english',
      '/training/12/ral','/training/12/ral/english',
      '/training/12/char','/training/12/char/english',
      '/training/12/sandi','/training/12/sandi/english',
      '/training/12/las','/training/12/las/english',
      '/training/12/sea','/training/12/sea/english',
      '/training/13/nyc','/training/13/nyc/english',
      '/training/13/new','/training/13/new/english',
      '/training/13/chi','/training/13/chi/english',
      '/training/14/nyc','/training/14/nyc/english',
      '/training/14/new','/training/14/new/english',
      '/training/14/chi','/training/14/chi/english',
      '/training/15/nyc','/training/15/nyc/english',
      '/training/15/new','/training/15/new/english',
      '/training/15/chi','/training/15/chi/english',
      '/training/16/dc','/training/16/dc/english',
      '/training/16/la','/training/16/la/english',
      '/training/16/reno','/training/16/reno/english',
      '/training/16/fort_lau','/training/16/fort_lau/english',
      '/training/16/sanfran','/training/16/sanfran/english',
      '/training/16/wpb','/training/16/wpb/english',
      '/training/16/miami','/training/16/miami/english',
      '/training/16/char','/training/16/char/english',
      '/training/16/sea','/training/16/sea/english',
      '/training/16/ral','/training/16/ral/english',
      '/training/16/bos','/training/16/bos/english',
      '/training/17/bos','/training/17/bos/english',
      '/training/17/dc','/training/17/dc/english',
      '/training/17/la','/training/17/la/english',
      '/training/17/reno','/training/17/reno/english',
      '/training/17/wpb','/training/17/wpb/english',
      '/training/17/miami','/training/17/miami/english',
      '/training/17/fort_lau','/training/17/fort_lau/english',
      '/training/17/sanfran','/training/17/sanfran/english',
      '/training/17/sea','/training/17/sea/english',
      '/training/18/bos','/training/18/bos/english',
      '/training/18/dc','/training/18/dc/english',
      '/training/18/la','/training/18/la/english',
      '/training/18/reno','/training/18/reno/english',
      '/training/18/wpb','/training/18/wpb/english',
      '/training/18/miami','/training/18/miami/english',
      '/training/18/fort_lau','/training/18/fort_lau/english',
      '/training/18/sanfran','/training/18/sanfran/english',
      '/training/18/ral','/training/18/ral/english',
      '/training/18/char','/training/18/char/english',
      '/training/18/sea','/training/18/sea/english',
      '/training/19/chi','/training/19/chi/english',
      '/training/19/la','/training/19/la/english',
      '/training/19/ral','/training/19/ral/english',
      '/training/19/char','/training/19/char/english',
      '/training/19/sandi','/training/19/sandi/english',
      '/training/19/las','/training/19/las/english',
      '/training/19/bos','/training/19/bos/english',
      '/training/20/chi','/training/20/chi/english',
      '/training/20/nyc','/training/20/nyc/english',
      '/training/20/miami','/training/20/miami/english',
      '/training/20/wpb','/training/20/wpb/english',
      '/training/20/fort_lau','/training/20/fort_lau/english',
      '/training/20/la','/training/20/la/english',
      '/training/20/reno','/training/20/reno/english',
      '/training/20/sanfran','/training/20/sanfran/english',
      '/training/20/char','/training/20/char/english',
      '/training/20/sea','/training/20/sea/english',
      '/training/20/ral','/training/20/ral/english',
      '/training/20/bos','/training/20/bos/english',
      '/training/21/lon','/training/21/lon/english',
      '/training/22/sanfran','/training/22/sanfran/english',
      '/training/23/nyc','/training/23/nyc/english',
      '/training/24/miami','/training/24/miami/english',
      '/training/25/miami','/training/25/miami/english',
      '/training/25/wpb','/training/25/wpb/english',
      '/training/25/fort_lau','/training/25/fort_lau/english',
      '/training/25/la','/training/25/la/english',
      '/training/25/reno','/training/25/reno/english',
      '/training/25/sea','/training/25/sea/english',
      '/training/26/lon','/training/26/lon/english',
      '/training/27/lon','/training/27/lon/english',
      '/training/28/lon','/training/28/lon/english',
      '/training/29/lon','/training/29/lon/english',
      '/training/30/ral','/training/30/ral/english',
      '/training/30/char','/training/30/char/english',
      '/training/31/lon','/training/31/lon/english',
      '/training/32/nyc','/training/32/nyc/english',
      '/training/32/chi','/training/32/chi/english',
      '/training/32/phl','/training/32/phl/english',
      '/training/32/dc', '/training/32/dc/english',
      '/training/32/la','/training/32/la/english',
      '/training/32/bos','/training/32/bos/english',
      '/training/32/miami','/training/32/miami/english',
      '/training/32/fort_lau','/training/32/fort_lau/english',
      '/training/32/nola','/training/32/nola/english',
      '/training/32/reno','/training/32/reno/english',
      '/training/32/sanfran','/training/32/sanfran/english',
      '/training/32/wpb','/training/32/wpb/english',
      '/training/32/ral','/training/32/ral/english',
      '/training/32/char','/training/32/char/english',
      '/training/32/sandi','/training/32/sandi/english',
      '/training/32/las','/training/32/las/english',
      '/training/32/buff','/training/32/buff/english',
      '/training/32/sea','/training/32/sea/english',
      '/training/33/chi','/training/33/chi/english',
      '/training/33/phl','/training/33/phl/english',
      '/training/33/dc', '/training/33/dc/english',
      '/training/33/la','/training/33/la/english',
      '/training/33/bos','/training/33/bos/english',
      '/training/33/miami','/training/33/miami/english',
      '/training/33/fort_lau','/training/33/fort_lau/english',
      '/training/33/nola','/training/33/nola/english',
      '/training/33/reno','/training/33/reno/english',
      '/training/33/sanfran','/training/33/sanfran/english',
      '/training/33/wpb','/training/33/wpb/english',
      '/training/33/ral','/training/33/ral/english',
      '/training/33/char','/training/33/char/english',
      '/training/33/las','/training/33/las/english',
      '/training/34/la','/training/34/la/english',
      '/training/35/new','/training/35/new/english',
      '/training/36/nyc','/training/36/nyc/english',
      '/training/37/chi','/training/37/chi/english',
      '/training/38/bos','/training/38/bos/english',
      '/training/39/sandi','/training/39/sandi/english',
      '/training/40/lon','/training/40/lon/english',
    ];

  return useRoutes(trainingVersions.map(path => ({path, element})));
}